import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { OrdersService } from './public/orders.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class OrderRecipientAuthGuard {
  constructor(private router: Router, private ordersService: OrdersService) {}

  canActivate(next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const token = next.data.legacy ? next.paramMap.get('orderId') : next.queryParamMap.get('token');
    if (!token) {
      return of(false);
    }
    return this.ordersService.authenticateOrderRecipient(token).pipe(map(() => true));
  }
}
